<template>
  <el-collapse v-model="activeNames">
    <el-collapse-item title="User" name="user" v-if="iocDetailsContent && showUser">
      <div
        :class="{
          'display-none': $_.isEmpty(iocDetailsContent.sourceSid) && !$_.isNumber(iocDetailsContent.sourceSid)
        }"
      >
        <span class="subtitle2">SID</span>
        <span class="value cursor-pointer" @click="gotoThreatHunting">
          {{ iocDetailsContent.sourceSid }} <span class="material-icons" v-show="insightsEnabled"> search </span>
        </span>
      </div>
      <div
        :class="{
          'display-none': $_.isEmpty(iocDetailsContent.logonUser) && !$_.isNumber(iocDetailsContent.logonUser)
        }"
      >
        <span class="subtitle2">Name</span> <span class="value">{{ iocDetailsContent.logonUser }}</span>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import moment from "moment-timezone";
import { mapGetters } from "vuex";

export default {
  name: "WindowsUserIocEventDetails",
  props: {
    iocDetailsContent: {
      default: () => {
        return {};
      },
      type: [Object]
    }
  },
  data() {
    return {
      activeNames: ["user"]
    };
  },
  computed: {
    ...mapGetters(["insightsEnabled"]),
    showUser: function() {
      return _.intersection(["sourceSid", "logonUser"], Object.keys(this.iocDetailsContent)).length > 0;
    }
  },
  methods: {
    gotoThreatHunting() {
      if (!this.insightsEnabled) {
        return false;
      }
      let startTimeHrBefore = moment(this.iocDetailsContent.seenTime).subtract({ days: 7 });
      let startTimeHrAfter = moment(this.iocDetailsContent.seenTime);

      let threatHuntParam = `start_time:${startTimeHrBefore.toISOString()}+end_time:${startTimeHrAfter.toISOString()}+edgeName:in:exec:user+sourceSid:eq:${
        this.iocDetailsContent.sourceSid
      }+agentId:eq:${this.iocDetailsContent.agentId}`;
      this.$router.push({
        name: "threat-hunting",
        query: { search: threatHuntParam }
      });
    }
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";

.el-collapse {
  overflow: scroll;
  border-bottom: none;
}

>>> .el-collapse-item__header {
  height: 40px;
  line-height: 40px;
  background-color: var(--gray-50);
  border-bottom: 1px solid var(--border-color);
  padding-left: 15px;
  font-size: 10px;
  font-weight: normal;
  color: inherit;
  line-height: 32px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.el-collapse-item >>> .el-collapse-item__content,
.ml-metadata_block {
  > div {
    display: flex;
    flex-wrap: nowrap;
    padding: 10px;

    > .subtitle2,
    .value {
      flex-grow: 1;
      align-self: auto;
      width: 50%;

      .material-icons {
        font-size: 16px;
        vertical-align: text-bottom;
      }
    }
  }
}

.ml-metadata_block {
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/feed/ioc-details/WindowsUserIocEventDetails.vue